import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {FilterLinkComponent} from '../filter-link/filter-link.component';
import {FiltersGamesListBox} from "./filters-games-list.box";
import {
  IArenaGameFilterEditorViewModel
} from "../../../services/games-filter/arena-filters/arena-game-filter-editor-view-model.interface";

export interface FilterLinkListComponentProps {
  filters: IArenaGameFilterEditorViewModel[];
  onToggle: (filter: IArenaGameFilterEditorViewModel) => void
}
export class FilterLinkListComponent extends OrbitComponent<FilterLinkListComponentProps> {

  private _toggleHandler = (filter: IArenaGameFilterEditorViewModel) => {
    this.props.onToggle(filter);
  };

  private _renderOneFilter(filter: IArenaGameFilterEditorViewModel) {
    return (
      <FilterLinkComponent key={filter.id} filter={filter} onChange={this._toggleHandler} />
    );
  }

  render() {
    return (
      <FiltersGamesListBox className={'cy-filters-games-list'}>
        {this.props.filters.map(filter => this._renderOneFilter(filter))}
      </FiltersGamesListBox>
    );
  }
}
